export const activeRentalKeys = {
    all: ['active-rentals'] as const,
    list: (filters: {mine: boolean; yardId: string | null}) =>
        [...activeRentalKeys.all, filters] as const,
}
